<template>
	<div class="container">
		<Row :gutter="17">
			<Col span="12">
				<Tabs type="card" id="report-data-gide">
					<TabPane label="高校专利报告">
						<textlist type="universityPatentReport"></textlist>
					</TabPane>
					<TabPane label="全国专利分析报告">
						<textlist type="nationalPatentReport"></textlist>
					</TabPane>
					<!--<a slot="extra" style="line-height: 30px;">更多> ></a>-->
				</Tabs>
			</Col>
			<Col span="12">
				<carouselist></carouselist>
			</Col>
		</Row>

	</div>

</template>

<script>
	import textlist from '@/view/index/data/textlist.vue'
	import carouselist from '@/view/index/data/carouselist.vue'
	
	export default {
		name: 'btnList',
		data() {
			return {

			};
		},

		components: {
			textlist: textlist,
			carouselist: carouselist
		}
	}
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/view/index/dataCenter/index.vue